import styled from './assistencia.module.css';
import Header from '../../components/Header';
import Menu from '../../components/Menu';
import Listaassistencias from '../../components/ListaAssistencias';

function Assistencia() {
    return (
        <div className={styled.page}>
            <Menu menu='assistencia' />
            <div className={styled.container}>
                <Header page='Assistências' />
                <div className={styled.content}>
                    <div className={styled.card}>
                        <div className={styled.cardheader}>
                            <div className={styled.cardtitle}>
                                <a>Assistências</a>
                                <div className={styled.cardtitleline}></div>
                            </div>

                        </div>
                        <div className={styled.cardcontent}>
                            <div className={styled.apppedidos}>
                                <div className={styled.apppedidosframe101}>

                                    <div className={styled.applistapedidos}>
                                        <div className={styled.applistapedidos100}>
                                            <div className={styled.applistapedidos99}>
                                                 <Listaassistencias/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default Assistencia;